const RANKING_ITEMS = [
  { rank: 1, title: '最新上映大片热度榜', desc: '2025暑期档最受期待影片排行', hot: '🔥 256.8万热度', change: 'up' },
  { rank: 2, title: '本周播放量最高', desc: '一周内播放量突破千万的热门内容', hot: '📈 198.3万热度', change: 'up' },
  { rank: 3, title: '用户收藏最多', desc: '全网用户争相收藏的经典佳作', hot: '⭐ 167.5万热度', change: 'same' },
  { rank: 4, title: '讨论度爆表', desc: '弹幕评论互动最活跃的影视剧集', hot: '💬 142.1万热度', change: 'up' },
  { rank: 5, title: '24小时飙升榜', desc: '单日播放量增长最快的内容榜单', hot: '🚀 89.6万热度', change: 'up' },
];

function RankBadge({ rank }: { rank: number }) {
  if (rank === 1) return <span className="w-7 h-7 flex items-center justify-center bg-accent-500 text-background-50 rounded-lg text-xs font-bold">{rank}</span>;
  if (rank === 2) return <span className="w-7 h-7 flex items-center justify-center bg-accent-400/80 text-background-50 rounded-lg text-xs font-bold">{rank}</span>;
  if (rank === 3) return <span className="w-7 h-7 flex items-center justify-center bg-accent-300/80 text-background-50 rounded-lg text-xs font-bold">{rank}</span>;
  return <span className="w-7 h-7 flex items-center justify-center bg-background-200 text-foreground-600 rounded-lg text-xs font-bold">{rank}</span>;
}

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950">热度榜单</h2>
          <p className="text-sm text-foreground-500 mt-2">实时追踪最受欢迎的热门内容</p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {RANKING_ITEMS.map((item) => (
            <div
              key={item.rank}
              className="flex items-center gap-4 bg-background-50 border border-background-200/60 rounded-xl p-4 hover:border-primary-200 transition-all cursor-pointer group"
            >
              <RankBadge rank={item.rank} />
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors">{item.title}</h3>
                <p className="text-xs text-foreground-500 mt-0.5">{item.desc}</p>
              </div>
              <div className="flex-shrink-0 text-right">
                <span className="text-xs font-medium text-accent-600">{item.hot}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}